<template>
  <div class="bg_home">
    <!-- <v-window v-model="window" class="elevation-1" vertical>
      <v-window-item>
        <PR></PR>
      </v-window-item>
    </v-window>-->
    <Preview id="preview" class="pb-10"></Preview>
    <v-row>
      <v-col align="right">
        <v-item-group
          v-model="window"
          class="shrink mr-6 btn_group"
          mandatory
          tag="v-flex"
        >
          <v-item
            v-for="(item, i) in navigation"
            :key="i"
            v-slot:default="{ active, toggle }"
          >
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <div @click="toggle">
                  <v-card
                    :dark="active"
                    :style="
                      active
                        ? 'background-image: linear-gradient(to right,#aa076b ,#61045f)'
                        : 'white'
                    "
                    tile
                    class="elevation-4"
                    v-on="on"
                    :input-value="active"
                    @click="$vuetify.goTo(item.id)"
                  >
                    <v-avatar tile>
                      <v-icon size="18">{{ item.icon }}</v-icon>
                    </v-avatar>
                  </v-card>
                </div>
              </template>
              <v-row align="center" justify="center">
                <!-- <v-btn icon dark>
                  <v-icon size="20">{{item.icon}}</v-icon>
                </v-btn>-->

                <span class="mx-2">{{ item.name_th }}</span>
              </v-row>
            </v-tooltip>
          </v-item>
        </v-item-group>
      </v-col>
    </v-row>

    <Meaning class="pt-12 pb-10" id="meaning"></Meaning>
    <PR class="pt-8 pb-10" id="pr"></PR>
    <News class="pt-12 pb-10" id="news"></News>
    <Calendar class="pt-12 pb-10" id="calendar"></Calendar>
    <Personnel class="pt-12 pb-10" id="personnel"></Personnel>
    <Chart class="pt-12 pb-10" id="chart"></Chart>
    <Book class="pt-12 pb-10" id="book"></Book>

    <Footer></Footer>
  </div>
</template>
<script>
import Preview from "../components/HomePage/Preview";
import Meaning from "../components/HomePage/Meaning";
import PR from "../components/HomePage/PR";
import News from "../components/HomePage/News";
import Calendar from "../components/HomePage/Calendar";
import Personnel from "../components/HomePage/Personnel";
import Chart from "../components/HomePage/Chart";
import Book from "../components/HomePage/Book";
import Footer from "./Footer";

export default {
  components: {
    Preview,
    Meaning,
    PR,
    News,
    Calendar,
    Personnel,
    Chart,
    Book,
    Footer,
  },
  data() {
    return {
      navigation: [
        {
          name: "Home",
          name_th: "หน้าหลัก",
          id: "#preview",
          icon: "mdi-home",
        },
        {
          name: "Meaning",
          name_th: "วิสัญญีวิทยา",
          id: "#meaning",
          icon: "mdi-hospital-building",
        },
        {
          name: "Pr",
          name_th: "ประชาสัมพันธ์",
          id: "#pr",
          icon: "mdi-bullhorn",
        },
        {
          name: "News",
          name_th: "ข่าวสารและกิจกรรม",
          id: "#news",
          icon: "mdi-book-open",
        },
        {
          name: "Calendar",
          name_th: "ปฏิทินและกิจกรรม",
          id: "#calendar",
          icon: "mdi-calendar",
        },
        {
          name: "Personnel",
          name_th: "บุคลากรสาขาวิชาวิสัญญีวิทยา",
          id: "#personnel",
          icon: "mdi-account",
        },
        {
          name: "Chart",
          name_th: "ยอดบริการ",
          id: "#chart",
          icon: "mdi-chart-line",
        },
        {
          name: "Book",
          name_th: "หนังสือจำหน่าย",
          id: "#book",
          icon: "mdi-book-open-variant",
        },
      ],
      window: 0,
    };
  },
};
</script>
